import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Company from "../pages/company/page";
import Works from "../pages/works/page";
import Recruit from "../pages/recruit/page";
import Contact from "../pages/contact/page";
import Map from "../pages/map/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/company", element: <Company /> },
  { path: "/works", element: <Works /> },
  { path: "/recruit", element: <Recruit /> },
  { path: "/contact", element: <Contact /> },
  { path: "/map", element: <Map /> },
  { path: "/access", element: <Map /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
